<template>
  <div>
    <van-form class="q_mar_b100px">
      <van-field required v-model="form.realName" maxlength="10" clearable label="真实姓名" placeholder="请输入真实姓名"
                 input-align="right"/>
      <van-field required name="sex" label="性别" input-align="right">
        <template #input>
          <van-radio-group v-model="form.sex" direction="horizontal">
            <van-radio name="0" checked-color="#FF5733">男</van-radio>
            <van-radio name="1" checked-color="#FF5733">女</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <!--      <van-field required v-model="form.age" clearable label="年龄" placeholder="请输入年龄" type="digit"-->
      <!--                 input-align="right"/>-->
      <!--      <van-field required name="realPic" label="个人照片" input-align="right">-->
      <!--        <template #input>-->
      <!--          <van-uploader v-model="form.photo" :max-count="1" :after-read="afterRead"/>-->
      <!--        </template>-->
      <!--      </van-field>-->
      <van-field required v-model="form.realPhone" clearable label="联系电话" maxlength="11" placeholder="请输入联系电话"
                 input-align="right"/>
      <van-field required v-model="form.identity" clearable label="身份证号" maxlength="21" placeholder="请输入身份证号"
                 input-align="right"/>
<!--      <van-field required v-model="form.volunteerNo" clearable label="志愿者号" maxlength="21" placeholder="请输入志愿者号"-->
<!--                 input-align="right"/>-->
      <!--      <van-field required v-model="form.wechar" maxlength="20" clearable label="微信号码" placeholder="请输入微信号码"-->
      <!--                 input-align="right"-->
      <!--                 :rules="[{ pattern:/^[a-zA-Z][a-zA-Z\d_-]{5,19}$/, message: '微信账号仅支持6-20个字母、数字、下划线或减号，以字母开头' }]"-->
      <!--      />-->
      <!--      <van-field required v-model="form.email" maxlength="30" clearable label="电子邮箱" placeholder="请输入电子邮箱"-->
      <!--                 input-align="right"/>-->
      <van-field required name="realIdentity" label="个人身份" input-align="right">
        <template #input>
          <van-radio-group v-model="form.realIdentity" direction="horizontal">
            <van-radio name="已就业" checked-color="#FF5733">已就业</van-radio>
            <van-radio name="在校生" checked-color="#FF5733">在校生</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <div v-if="form.realIdentity == '已就业'">
        <van-field required readonly clickable name="picker" :value="form.education" label="最高学历" placeholder="请选择学历"
                   @click="showPicker = true" input-align="right"/>
        <van-popup v-model="showPicker" position="bottom">
          <van-picker show-toolbar :columns="columns" @confirm="onConfirm" @cancel="showPicker = false"/>
        </van-popup>
        <van-field required v-model="form.school" clearable label="毕业院校" maxlength="20" placeholder="请输入毕业院校"
                   @input="schoolIn" input-align="right"
                   :rules="[{ pattern:/^[\u4e00-\u9fa5]+$/, message: '只能输入中文' }]"
        />
        <van-field required v-model="form.subject" clearable label="所学专业" maxlength="20" placeholder="请输入所学专业"
                   @input="subjectIn" input-align="right"
                   :rules="[{ pattern:/^[\u4e00-\u9fa5]+$/, message: '只能输入中文' }]"
        />
        <van-field required v-model="form.employedUnit" clearable label="就职单位" maxlength="20" placeholder="请输入就职单位"
                   @input="employedUnitIn"
                   input-align="right"
                   :rules="[{ pattern:/^[\u4e00-\u9fa5]+$/, message: '只能输入中文' }]"
        />
        <van-field required v-model="form.jobTitle" clearable label="担任职务" maxlength="20" placeholder="请输入担任职务"
                   @input="jobTitleIn" input-align="right"
                   :rules="[{ pattern:/^[\u4e00-\u9fa5]+$/, message: '只能输入中文' }]"
        />
      </div>
      <div v-if="form.realIdentity == '在校生'">
        <van-field required readonly clickable name="picker" :value="form.education" label="目前学历" placeholder="请选择学历"
                   @click="showPicker1 = true" input-align="right"/>
        <van-popup v-model="showPicker1" position="bottom">
          <van-picker show-toolbar :columns="columns1" @confirm="onConfirm1" @cancel="showPicker1 = false"/>
        </van-popup>
        <van-field required v-model="form.school" clearable label="就读院校" maxlength="20" placeholder="请输入就读院校"
                   @input="schoolIn" input-align="right"/>
      </div>
      <!--      <van-field required name="isJoin" label="参与过志愿服务" input-align="right">-->
      <!--        <template #input>-->
      <!--          <van-radio-group v-model="form.isJoin" direction="horizontal">-->
      <!--            <van-radio name="1" checked-color="#FF5733">是</van-radio>-->
      <!--            <van-radio name="0" checked-color="#FF5733">否</van-radio>-->
      <!--          </van-radio-group>-->
      <!--        </template>-->
      <!--      </van-field>-->
      <!--      <van-field v-if="form.isJoin == '1'" required v-model="form.joinDays" type="digit" clearable label="参与时长(天)"-->
      <!--                 placeholder="请输入参与时长"-->
      <!--                 input-align="right"/>-->
      <!--      <van-field required v-model="form.hobby" clearable rows="2" autosize label="特长及爱好" type="textarea" maxlength="100"-->
      <!--                 placeholder="请输入特长及爱好" show-word-limit input-align="right"/>-->


      <van-field  readonly clickable name="picker" :value="form.deptName" label="要加入的队伍" placeholder="请选择要加入的队伍"
                 v-if="userDeptList.length==0"
                 @click="showDeptPicker = true" input-align="right"/>
      <van-popup v-model="showDeptPicker" position="bottom">
        <van-picker show-toolbar :columns="deptColumns" @confirm="onConfirmDept" @cancel="showDeptPicker = false"/>
      </van-popup>

    </van-form>
    <van-goods-action v-show="isOriginHei">
      <!-- 身份未认证时，跳转身份认证界面(Identity.vue)；认证了之后每次修改，将表单提示到后台审核，无需再跳身份认证 -->
      <van-goods-action-button type="danger" color="#FF5733" text="确认提交" @click="saveBaseInfo()"
                               :loading="buttonLoading" :disabled="buttonLoading"/>

      <!-- 正在审核时 -->
      <!--      <van-goods-action-button type="danger" color="#cccccc" text="待审核"/>-->
    </van-goods-action>
  </div>
</template>

<script>
import {getToken} from "@/utils/auth";
import axios from "axios";
import {baseUrl, isRelogin} from "@/utils/request";
import {Dialog} from "vant";
import store from "@/store";
import {validatePhoneNumber} from "@/utils/validate";
import {updateBaseInfo} from "@/api/user";
import {selectUserDeptByUserId} from "@/api/userDept";
import {listJoin} from "@/api/join";
import {wxCloseShare} from "@/utils/jiutang";

export default {
  name: 'Basicdata',
  props: {
    msg: String
  },
  data() {
    return {
      originHeight: 0, 	// 原始高度
      screenHeight: 0, 	// 实际高度
      isOriginHei: true, 	// 显示或隐藏底部信息
      buttonLoading: false,
      columns: ['高中', '大专', '本科', '研究生', '博士', '其他'],
      columns1: ['高中', '大专', '本科', '研究生', '博士', '其他'],
      deptColumns: ['一大队', '二大队'],
      showPicker: false,
      showPicker1: false,
      showDeptPicker: false,
      user: {},
      form: {
        id: '',
        realName: '',
        sex: '1',
        realIdentity: '已就业',
        isJoin: '0',
        age: '',
        realPic: '',
        realPhone: '',
        wechar: '',
        email: '',
        education: '',
        school: '',
        subject: '',
        employedUnit: '',
        jobTitle: '',
        joinDays: '',
        hobby: '',
        photo: [],
        identity: '',
        deptId: '',
        deptName: ''
      },
      userDeptList: [],
      deptList: []
    }
  },
  created() {
    wxCloseShare()
    this.$modal.loading('加载个人信息')
    this.$store.dispatch("GetInfo").then(res => {
      this.user = res.data
      this.reset()
    }).then(() => {
      return selectUserDeptByUserId()
    }).then(res => {
      // this.userDeptList = res.data
      return listJoin()
    }).then(res => {
      this.deptList = res.rows
      this.deptColumns = res.rows.map(item => {
        return item.deptName
      })
    }).finally(() => {
      this.$modal.closeLoading()
    })
  },
  methods: {
    watchResize() {
      //实时变化的窗口高度
      this.screenHeight = document.documentElement.clientHeight;
    },
    /**
     * 保存基本信息
     */
    saveBaseInfo() {
      if (!this.form.realName) {
        this.$modal.alert("请输入真实姓名")
        return
      }

      var pattern = /^[\u4e00-\u9fa5]+$/
      if (!pattern.test(this.form.realName)) {
        this.$modal.alert("真实姓名必须为汉字")
        return
      }

      // if (!this.form.age) {
      //   this.$modal.alert("请输入年龄")
      //   return
      // }


      // if (this.form.photo.length == 0) {
      //   this.$modal.alert("请上传个人照片")
      //   return
      // }

      if (!this.form.realPhone) {
        this.$modal.alert("请输入联系电话")
        return
      }


      if (!validatePhoneNumber(this.form.realPhone)) {
        this.$modal.alert("联系电话格式有误")
        return
      }

      if (!this.form.identity) {
        this.$modal.alert("请输入身份证号")
        return
      }

      // if (!this.form.volunteerNo) {
      //   this.$modal.alert("请输入志愿者号")
      //   return
      // }

      // if (!this.form.wechar) {
      //   this.$modal.alert("请输入微信号码")
      //   return
      // }
      // if (!this.form.email) {
      //   this.$modal.alert("请输入电子邮箱")
      //   return
      // }

      // if (!validateEmail(this.form.email)) {
      //   this.$modal.alert("电子邮箱格式有误")
      //   return
      // }

      if (!this.form.realIdentity) {
        this.$modal.alert("请选择个人身份")
        return
      }

      if (this.form.realIdentity == '在校生') {
        // if (this.form.age < 12) {
        //   this.$modal.alert("在校生人员年龄不得小于12岁")
        //   return
        // }
        // if (this.form.age > 60) {
        //   this.$modal.alert("在校生人员年龄不得大于60岁")
        //   return
        // }
      }

      if (this.form.realIdentity == '已就业') {
        // if (this.form.age < 18) {
        //   this.$modal.alert("已就业人员年龄不得小于18岁")
        //   return
        // }
        // if (this.form.age > 100) {
        //   this.$modal.alert("已就业人员年龄不得大于100岁")
        //   return
        // }
      }

      if (this.form.realIdentity == '已就业') {
        if (!this.form.education) {
          this.$modal.alert("请选择学历")
          return
        }
        if (!this.form.school) {
          this.$modal.alert("请输入毕业院校")
          return
        }
        if (!this.form.subject) {
          this.$modal.alert("请输入所学专业")
          return
        }
        if (!this.form.employedUnit) {
          this.$modal.alert("请输入就职单位")
          return
        }
        if (!this.form.jobTitle) {
          this.$modal.alert("请输入担任职务")
          return
        }
      }
      if (this.form.realIdentity == '在校生') {
        if (!this.form.education) {
          this.$modal.alert("请选择学历")
          return
        }
        if (!this.form.school) {
          this.$modal.alert("请输入就读院校")
          return
        }
      }

      // if (this.userDeptList == 0) {
      //   if (!this.form.deptId) {
      //     this.$modal.alert("请选择所属队伍")
      //     return
      //   }
      // }


      // if (!this.form.isJoin) {
      //   this.$modal.alert("请选择是否参与过志愿服务")
      //   return
      // }


      // if (this.form.isJoin == '1') {
      //   if (!this.form.joinDays) {
      //     this.$modal.alert("请输入参与时长")
      //     return
      //   }
      // }

      // if (!this.form.hobby) {
      //   this.$modal.alert("请输入特长及爱好")
      //   return
      // }

      this.buttonLoading = true
      //修改基本资料
      this.$modal.loading("正在保存")
      // this.form.realPic = this.form.photo[0].url
      updateBaseInfo(this.form).then(res => {
        this.buttonLoading = false
        this.$store.dispatch("GetInfo")
        this.$modal.success("保存成功")
        setTimeout(() => {
          this.$modal.closeLoading()

          // if (this.user.idCardAudit == null || this.user.idCardAudit.auditState == 0 || this.user.idCardAudit.auditState == 2) {
          //   this.$router.push({
          //     path: '/mine/Identity'
          //   });
          // } else {
          //   this.$router.push({
          //     path: '/mine/Basicd'
          //   });
          // }

          this.$router.push({
            path: '/mine/Basicd'
          });

        }, 1500);

      }).catch(() => {
        this.buttonLoading = false
        this.$modal.closeLoading()
      })

    },
    /**
     * 表单初始化
     */
    reset() {
      this.form.id = this.user.id
      this.form.realName = this.user.realName
      this.form.sex = this.user.sex
      this.form.realIdentity = this.user.realIdentity
      this.form.isJoin = this.user.isJoin
      this.form.age = this.user.age
      this.form.realPhone = this.user.realPhone
      this.form.wechar = this.user.wechar
      this.form.email = this.user.email
      this.form.education = this.user.education
      this.form.school = this.user.school
      this.form.subject = this.user.subject
      this.form.employedUnit = this.user.employedUnit
      this.form.jobTitle = this.user.jobTitle
      this.form.joinDays = this.user.joinDays
      this.form.hobby = this.user.hobby
      this.form.identity = this.user.identity
      // this.form.volunteerNo = this.user.volunteerNo
      // if (this.user.realPic && null != this.user.realPic) {
      //   this.form.photo = [{'url': this.user.realPic, isImage: true}]
      // }
      // console.log('photo', this.form.photo)
    },
    /**
     * 文件上传
     */
    afterRead(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      let param = new FormData();
      param.append('file', file.file);//通过append向form对象添加数据
      let config = {
        headers: {'Content-Type': 'multipart/form-data', 'Authorization': 'Bearer ' + getToken()}
      };
      //添加请求头
      axios.post(baseUrl + "/h5/common/upload", param, config).then(res => {
        if (res.data.code == 401) {
          Dialog.confirm({
            title: '提示', message: '登录状态已过期，您可以继续留在该页面，或者重新登录', confirmButtonText: '重新登录', cancelButtonText: '取消'
          }).then(() => {
            isRelogin.show = false
            store.dispatch('LogOut').then(() => {
              location.href = '/h5/mine/sign'
              // location.href = '/mine/sign'
            })
          }).catch(() => {
            isRelogin.show = false
          });
        } else if (res.data.code == 500) {
          this.$modal.alert('上传失败，请重新上传')
          file.status = 'failed';
          file.message = '上传失败';
        } else {
          file.status = '';
          file.message = '';
          let pic = {'url': res.data.url}
          this.form.photo = [pic]
        }
      })
    },
    onConfirm(value) {
      this.form.education = value;
      this.showPicker = false;
    },
    onConfirm1(value) {
      this.form.education = value;
      this.showPicker1 = false;
    },
    onConfirmDept(value) {
      this.deptList.forEach(item => {
        if (item.deptName == value) {
          this.form.deptId = item.deptId;
        }
      })
      this.form.deptName = value
      this.showDeptPicker = false;
    },
    /**
     * 下一步
     */
    next() {
      this.$router.push({
        path: '/mine/Identity'
      });
    },
    schoolIn(value) {
      this.form.school = this.sumIn(value)
    },
    subjectIn(value) {
      this.form.subject = this.sumIn(value)
    },
    employedUnitIn(value) {
      this.form.employedUnit = this.sumIn(value)
    },
    jobTitleIn(value) {
      this.form.jobTitle = this.sumIn(value)
    },
    sumIn(value) {
      var part = /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/im;
      if (part.test(value)) {// 如果包含特殊字符
        console.log(value.replace(new RegExp(part, "g"), ""))
        return value.replace(new RegExp(part, "g"), "")
      } else {
        return value
      }
    }
  },
  mounted() {
    //首次进入的原始高度
    this.originalHeight = document.documentElement.clientHeight;
    //监听屏幕变化并获取到屏幕原始高度
    window.addEventListener('resize', this.watchResize);

  },
  beforeDestroy() {			//删除对resize的监听变化
    window.removeEventListener("resize", this.watchResize);
  },
  watch: {
    screenHeight(newHeight) { //监听屏幕高度变化
      this.isOriginHei = this.originalHeight <= newHeight;
    }
  },
}
</script>
<style scoped="scoped">
>>> .van-goods-action-button--last {
  margin-right: 80px;
}

.van-goods-action-button--first {
  margin-left: 80px;
}

.van-goods-action {
  box-shadow: 0 0 10px #f2f3f7;
  height: 60px;
}

>>> .van-field__label {
  width: 7.2em;
}
</style>
